import { Component, Input, OnInit, inject } from '@angular/core';
import { MenuItem } from 'src/app/shared/types/Menu';
import { IconComponent } from "../../icon/icon.component";
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-menu-item',
  standalone: true,
  imports: [CommonModule, RouterModule, IconComponent, MenuItemComponent], // Important: self-import for recursion
  templateUrl: './menu-item.component.html',
  styleUrl: './menu-item.component.css'
})
export class MenuItemComponent implements OnInit {
  @Input() menu!: MenuItem;
  @Input() toggleSubMenu: (menu: any) => void = () => {};
  private router = inject(Router);

  ngOnInit(): void {
  }
  isActive(path?: string) {
    if (!path) {
      return false;
    }
    return this.router.isActive(path, {
      paths: 'exact',
      queryParams: 'subset',
      fragment: 'ignored',
      matrixParams: 'subset',
    });
  }


  
}
